/* eslint-disable class-methods-use-this */

import {findTimeZone} from '../../../../helpers/dateTimeHelpers';
import {AtomParamTypesEnum} from '../expressionAtomModel';
import {buildEnumParameter, buildParameter} from '../expressionParamHelpers';
import {
  baseMethods,
  ConvertMethod,
  DateTimeResult,
  MethodCategoriesEnum,
  NumberResult,
  ResultType,
  ResultTypesEnum,
  StaticallyTypedMethod,
  StringResult,
} from './internal';

enum DateFormatsEnum {
  DATE_TIME = 'date_time',
  DATE = 'date',
  TIME = 'time',
}

const DATE_DEFAULT_LOCALE = 'en-US';

class DateFormatter extends ConvertMethod {
  constructor() {
    super(StringResult);
  }

  getAtomDefaultParameters() {
    return {
      format: DateFormatsEnum.DATE_TIME,
      abbreviated: false,
      timezone: findTimeZone(),
      locale: DATE_DEFAULT_LOCALE,
    };
  }

  getParameters() {
    return [
      buildEnumParameter('format', DateFormatsEnum),
      buildParameter('abbreviated', AtomParamTypesEnum.BOOLEAN),
      buildParameter('timezone', AtomParamTypesEnum.STRING, 'timezone'),
      buildParameter('locale', AtomParamTypesEnum.STRING),
    ];
  }
}

export enum TimePeriodsEnum {
  SECOND = 'second',
  MINUTE = 'minute',
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

class AddPeriodMethod extends StaticallyTypedMethod {
  constructor() {
    super(MethodCategoriesEnum.TRANSFORM, DateTimeResult);
  }

  getAtomDefaultParameters() {
    return {
      period: TimePeriodsEnum.DAY,
      amount: 1,
    };
  }

  getParameters() {
    return [
      buildEnumParameter('period', TimePeriodsEnum),
      buildParameter('amount', AtomParamTypesEnum.NUMBER),
    ];
  }
}

enum WeekStartsEnum {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
}

class StartOfPeriodMethod extends StaticallyTypedMethod {
  constructor() {
    super(MethodCategoriesEnum.TRANSFORM, DateTimeResult);
  }

  getAtomDefaultParameters() {
    return {
      period: TimePeriodsEnum.WEEK,
      timezone: findTimeZone(),
      week_start: WeekStartsEnum.SUNDAY,
    };
  }

  getParameters() {
    return [
      buildEnumParameter('period', TimePeriodsEnum),
      buildParameter('timezone', AtomParamTypesEnum.STRING, 'timezone'),
      buildEnumParameter('week_start', WeekStartsEnum),
    ];
  }
}

export const dateTimeType: ResultType = {
  name: ResultTypesEnum.DATETIME,
  properties: {},
  methods: {
    add: new AddPeriodMethod(),
    subtract: new AddPeriodMethod(),
    start_of: new StartOfPeriodMethod(),
    end_of: new StartOfPeriodMethod(),
    format: new DateFormatter(),
    to_iso8601: new ConvertMethod(StringResult),
    to_unix_timestamp: new ConvertMethod(NumberResult),
    ...baseMethods,
  },
};
